/* eslint-disable react-hooks/rules-of-hooks */

import { GridColumns } from '@mui/x-data-grid-pro';
import { Radio } from '@mui/material';
import React from 'react';
import { XGridDefaultColumn } from 'app/components/Common/XGrid/cells/XGridDefaults';
import { XGridOverflowCell } from '@AMIEWEB/Common/XGrid/cells/XGridOverflowCell';

const FacilityDefaultCell = {
  ...XGridDefaultColumn,
  flex: 0,
};
export const facilityViewInfo = (t,apiRef?): GridColumns => [
  {
    ...FacilityDefaultCell,
    field: 'facilityIDselect',
    headerName: t('*'),
    sortable: false,
    width: 15,
    renderCell: cellValues => {
      return ( <Radio checked={apiRef.current.isRowSelected(cellValues.id)} value={cellValues.id} name="radio-buttons" />)
    },
  },
  {
    ...FacilityDefaultCell,
    field: 'facilityId',
    headerName: t('search.globalSearch.facility.gridTags.facilityId'),
    width: 100,
  },
  {
    ...FacilityDefaultCell,
    field: 'facility',
    headerName: t('search.globalSearch.facility.gridTags.facility'),
    width: 300,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...FacilityDefaultCell,
    field: 'facilityStatus',
    headerName: t('search.globalSearch.facility.gridTags.facilityStatus'),
    width: 130,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...FacilityDefaultCell,
    field: 'positionsAvailable',
    headerName: t('search.globalSearch.facility.gridTags.positionsAvailable'),
    width: 120,
  },
  {
    ...FacilityDefaultCell,
    field: 'filesPending',
    headerName: t('search.globalSearch.facility.gridTags.filesPending'),
    width: 120,
    description: 'Status includes WFC and RFO',
  },
  {
    ...FacilityDefaultCell,
    field: 'filesOut',
    headerName: t('search.globalSearch.facility.gridTags.filesOut'),
    width: 100,
    description: 'Status includes Sent-Offer',
  },
  {
    ...FacilityDefaultCell,
    field: 'accountManager',
    headerName: t('search.globalSearch.facility.gridTags.accountManager'),
    width: 145,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...FacilityDefaultCell,
    field: 'city',
    headerName: t('search.globalSearch.facility.gridTags.city'),
    width: 130,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...FacilityDefaultCell,
    field: 'state',
    headerName: t('search.globalSearch.facility.gridTags.state'),
    width: 130,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...FacilityDefaultCell,
    field: 'division',
    headerName: t('search.globalSearch.facility.gridTags.division'),
    width: 120,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...FacilityDefaultCell,
    field: 'staffingVendor',
    headerName: t('search.globalSearch.facility.gridTags.staffingVendor'),
    width: 145,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...FacilityDefaultCell,
    field: 'techVendor',
    headerName: t('search.globalSearch.facility.gridTags.techVendor'),
    width: 145,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...FacilityDefaultCell,
    field: 'healthSystem',
    headerName: t('search.globalSearch.facility.gridTags.healthSystem'),
    width: 145,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...FacilityDefaultCell,
    field: 'contractAffiliate',
    headerName: 'Contract Affiliate',
    width: 170,
    renderCell: XGridOverflowCell()(),
  },
  {
    ...FacilityDefaultCell,
    field: 'orders',
    headerName: t('search.globalSearch.facility.gridTags.orders'),
    width: 100,
  },
];

export const facilityColumnVisibilityModel = {
  facilityId: true,
  facility: true,
  facilityStatus: true,
  positionsAvailable: false,
  filesPending:false,
  filesOut:false,
  accountManager: false,
  city: true,
  state: true,
  division: true,
  staffingVendor:false,
  techVendor:false,
  healthSystem:false,
  contractAffiliate:false,
  orders:false,
};
